module.exports = __webpack_public_path__ + "static/media/culture_02.2bf9a96f.jpg";